<template>
    <div>
        <base-crud
                crudName="Receitas"
                newText="Nova Receita"
                :table="recipeTable"
                :columns="columns"
                :options="options"
                :endPoint='endPoint'
                :enableAdd="false"
                :enableEdit="false"
                :enableDelete="false"
                :enableView="true"
                :enableSetStatus="true"
                :extra="actions"
                @callLinkModal="callLinkModal"
        >
        </base-crud>

        <div class="modal" id="linkModal">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h3>
                            Adicionar Vídeo da Receita
                            <i class="fa fa-camera pull-right" style="margin-top:3px;"></i>
                        </h3>
                    </div>
                    <div class="modal-body">
                        <form action="">
                            <div class="form-group">
                                <label for="link">Link</label>
                                <input type="text" v-model="link" class="form-control" id="link">
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-danger" data-dismiss="modal">
                            Cancelar
                            <i class="fa fa-remove"></i>
                        </button>

                        <button class="btn btn-success" @click="save">
                            Salvar
                            <i class="fa fa-save"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import BaseCrud from "../Base/BaseCrud";

    export default {
        data: function () {
            return {
                recipeTable: "recipeTable",
                users: [],
                pages: [],
                url: "",
                columns: ["id", "recipe_id", "name", "status", "photo", "actions"],
                tableData: [],
                options: {
                    sortable: ["id", "recipe_id", "status", "name"],
                    pagination: {chunk: 10, dropdown: false, nav: "scroll"},
                    perPage: 10,
                    perPageValues: [10, 25, 50, 100],
                    headings: {
                        recipe_id: "Receita",
                        name: "Nome",
                        photo: "Foto",
                        actions: "Ações"
                    },
                    templates: {
                        status: function (h, row, index) {
                            return row.status === 2 ? 'Inativo' : 'Ativo'
                        }
                    }
                },
                actions: [
                    {
                        id: 1,
                        name: "callLinkModal",
                        class: "btn btn-danger fa fa-camera",
                        title: "Link do Vídeo",
                        label: " "
                    },
                ],
                link: '',
                recipe: '',
                endPoint: "recipe/?with[]=videos"
            }
        },
        computed: {
            postUrl() {
                return this.$store.getters.api + this.endPoint;
            }
        },
        components: {
            BaseCrud
        },
        methods: {
            callLinkModal: function (data) {
                this.link = '';
                this.recipe = data.row.recipe_id;
                this.getProduct(function () {
                    $('#linkModal').modal('show');
                });
            },
            getProduct: function (callback) {
                const self = this;
                const api = self.$store.state.api + 'recipe?recipe_id=' + self.recipe + '&with[]=videos';

                self.$http
                    .get(api)
                    .then((response) => {
                        this.link = response.data.data[0].videos;
                        if (this.link.length > 0) {
                            this.link = this.link[0].link;
                            return callback();
                        }
                        this.link = '';
                        return callback();
                    })
                    .catch((error) => {
                        self.$error('Não foi possível buscar as Informações referente ao produto');
                    });
            },
            save: function () {
                const self = this;
                const api = self.$store.state.api + 'recipeVideo';

                self.$http
                    .post(api, {
                        link: self.link,
                        recipe_id: self.recipe
                    })
                    .then((response) => {
                        $('#linkModal').modal('hide');
                        self.$message(null, 'Link atualizado com sucesso', 'success');
                    })
                    .catch((error) => {
                        self.$error('Não foi possível atualizar o Link do Vídeo');
                    });
            }
        }
    };
</script>

<style scoped>
    .VuePagination {
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/Recipe/Crud.vue